module.exports = __webpack_public_path__ + "img/sortdown.svg";